import arTranslation from '../localization/locales/ar.json'
import bgTranslation from '../localization/locales/bg.json'
import csTranslation from '../localization/locales/cs.json'
import daTranslation from '../localization/locales/da.json'
import deTranslation from '../localization/locales/de.json'
import elTranslation from '../localization/locales/el.json'
import enTranslation from '../localization/locales/en.json'
import esTranslation from '../localization/locales/es.json'
import etTranslation from '../localization/locales/et.json'
import fiTranslation from '../localization/locales/fi.json'
import frTranslation from '../localization/locales/fr.json'
import heTranslation from '../localization/locales/he.json'
import hrTranslation from '../localization/locales/hr.json'
import huTranslation from '../localization/locales/hu.json'
import itTranslation from '../localization/locales/it.json'
import jaTranslation from '../localization/locales/ja.json'
import koTranslation from '../localization/locales/ko.json'
import ltTranslation from '../localization/locales/lt.json'
import lvTranslation from '../localization/locales/lv.json'
import nb_NOTranslation from '../localization/locales/nb-NO.json'
import nlTranslation from '../localization/locales/nl.json'
import plTranslation from '../localization/locales/pl.json'
import pt_BRTranslation from '../localization/locales/pt-BR.json'
import pt_PTTranslation from '../localization/locales/pt-PT.json'
import roTranslation from '../localization/locales/ro.json'
import ruTranslation from '../localization/locales/ru.json'
import skTranslation from '../localization/locales/sk.json'
import slTranslation from '../localization/locales/sl.json'
import srTranslation from '../localization/locales/sr.json'
import svTranslation from '../localization/locales/sv.json'
import thTranslation from '../localization/locales/th.json'
import trTranslation from '../localization/locales/tr.json'
import ukTranslation from '../localization/locales/uk.json'
import zh_HANSTranslation from '../localization/locales/zh-HANS.json'
import zh_HANTTranslation from '../localization/locales/zh-HANT.json'

export const resources = {
  en: {
    translation: enTranslation,
  },
  de: {
    translation: deTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  pt_BR: {
    translation: pt_BRTranslation,
  },
  pt_PT: {
    translation: pt_PTTranslation,
  },
  zh_HANS: {
    translation: zh_HANSTranslation,
  },
  zh_HANT: {
    translation: zh_HANTTranslation,
  },
  ko: {
    translation: koTranslation,
  },
  it: {
    translation: itTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
  fi: {
    translation: fiTranslation,
  },
  sv: {
    translation: svTranslation,
  },
  nb_NO: {
    translation: nb_NOTranslation,
  },
  tr: {
    translation: trTranslation,
  },
  ar: {
    translation: arTranslation,
  },
  hu: {
    translation: huTranslation,
  },
  pl: {
    translation: plTranslation,
  },
  da: {
    translation: daTranslation,
  },
  nl: {
    translation: nlTranslation,
  },
  el: {
    translation: elTranslation,
  },
  th: {
    translation: thTranslation,
  },
  lt: {
    translation: ltTranslation,
  },
  lv: {
    translation: lvTranslation,
  },
  et: {
    translation: etTranslation,
  },
  bg: {
    translation: bgTranslation,
  },
  hr: {
    translation: hrTranslation,
  },
  cs: {
    translation: csTranslation,
  },
  he: {
    translation: heTranslation,
  },
  ro: {
    translation: roTranslation,
  },
  sr: {
    translation: srTranslation,
  },
  sk: {
    translation: skTranslation,
  },
  sl: {
    translation: slTranslation,
  },
  uk: {
    translation: ukTranslation,
  },
}
